<template>
  <b-modal
    id="modalCopyPlan"
    ref="modalCopyPlan"
    class="modal-copy-plan"
    size="lg"
    header-bg-variant="info"
    header-text-variant="light"
    title="Liberar plano"
    :visible="isOpen"
    scrollable
    @show="plan = {}"
    @hide="$emit('close')"
  >
    <section class="modal-font-family modal-copy-plan__body">
      <div class="w-100 mb-3">
        <base-input-text
          class="w-100"
          :min="currentDate"
          v-model="plan.dueDate"
          label="Data de validade do plano"
          type="date"
          block
        />
      </div>

      <div class="d-flex align-items-end w-100">
        <base-input-select
          class="w-50 mr-2"
          v-model="plan.plan"
          label="Plano"
          placeholder="Selecione o plano"
          :options="plans"
          _key="key"
          _value="value"
        />
        <div class="w-50 d-flex flex-column">
          <label class="label">Preço</label>
          <money
            class="form-control_price"
            v-model="plan.price"
            v-bind="money"
          >
          </money>
        </div>
      </div>
    </section>

    <template #modal-footer>
      <section class="d-flex w-100 modal-font-family modal-copy-plan__footer">
        <base-button
          class="w-50"
          @click="$emit('close')"
          block
          danger
        >
          Cancelar
        </base-button>

        <b-overlay
          :show="addedCopyPlan"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block w-50"
        >
          <base-button
            :disabled="!isValid()"
            @click="$emit('submit', plan)"
            block
            success
          >
            Salvar
          </base-button>
        </b-overlay>
      </section>
    </template>
  </b-modal>
</template>

<script>

import moment from 'moment/moment'
export default {
  name: 'ModalCopyPlan',
  props: {
    isOpen: { type: Boolean, default: false },
    addedCopyPlan: { type: Boolean, default: false },
  },
  data(){
    return {
      plan: {},
      plans:[
        { key: "AN1HO" , value: "Plano anual" },
        { key: "PROMO" , value: "Plano promocional" },
        { key: "OUTRO" , value: "Outro" },
      ],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: true
      }
    }
  },
  emits: ['close', 'submit'],
  computed: {
    currentDate() {
      const user = this.$store.getters['user/current']
      return moment(user.currentDate).format('YYYY-MM-DD')
    },
  },
  methods: {
    isValid(){
      const price = this.plan.price ? Number(this.plan.price.toString().replace(/\D+/g, '')) : 0
      return this.plan.dueDate && this.plan.plan && price > 0
    }
  }
}
</script>

<style lang="scss" scoped>

.modal-copy-plan__body {
  display: flex;
  flex-direction: column;
}

.label {
  font-size: 18px;
  font-weight: 700;
}

.form-control_price {
  height: 48px;
  font-size: 16px;
  padding: 0 16px;
  border: 1px solid var(--border-input);
  border-radius: 4px;
  outline: none;

  &:hover {
    background: var(--light-gray);
  }

  &:focus {
    border-color: var(--blue);
  }
}

.modal-copy-plan__footer {
  gap: 16px;
}
</style>
